import { useContext, useEffect } from "react";
import { TransferContext } from "../../context/TransferContext";
import {
  STEP_ANNUITY_CONTACT,
  STEP_IDENTITY_VERIFICATION,
  STEP_IDENTITY_VERIFICATION_PERSONA,
  STEP_SPOUSE_NOTARY,
  STEP_TRANSFER_TASKS,
} from "../../class/transferDetails";
import { BRIDGE_DEVELOPMENT } from "../../typings";
import { AppContext } from "../../context/AppContext";
import { MockTask, TransferTask } from "../../class/transferTask";

const useTransferTasks = () => {
  const { appEnv } = useContext(AppContext);
  const isMock = appEnv === BRIDGE_DEVELOPMENT;
  const { currentScreen, goToScreen, transferTasks, getTransferTasks, refreshTransferInstructions, setHasFailedTask } =
    useContext(TransferContext);
  const spouseNotary = transferTasks.filter((task: MockTask | TransferTask) => task.type === "SPOUSAL_CONSENT")[0];
  const idTask = transferTasks.filter((task: MockTask | TransferTask) => task.type === "IDENTITY_VERIFICATION")[0];

  const showPersona = () => goToScreen(STEP_IDENTITY_VERIFICATION_PERSONA);

  const onFinishPersona = async (status?: string) => {
    console.log(status);
    if (!isMock) {
      await Promise.all([getTransferTasks(), refreshTransferInstructions()]);

      if (status === "approved") {
        if (spouseNotary && !(spouseNotary as TransferTask).completedOn) {
          goToScreen(STEP_SPOUSE_NOTARY);
        } else {
          goToScreen(STEP_ANNUITY_CONTACT);
        }
      }
      if (status === "needs_review") {
        setHasFailedTask(true);
        goToScreen(STEP_ANNUITY_CONTACT);
        return;
      }
    }
    if (spouseNotary) {
      goToScreen(STEP_SPOUSE_NOTARY);
    } else {
      goToScreen(STEP_ANNUITY_CONTACT);
    }
  };

  const onClickGotIt = () => goToScreen(STEP_ANNUITY_CONTACT);

  const goToNextTask = () => {
    if (!isMock) {
      // check tasks
      if (idTask && !(idTask as TransferTask).completedOn && currentScreen === STEP_TRANSFER_TASKS) {
        goToScreen(STEP_IDENTITY_VERIFICATION);
      } else if (
        spouseNotary &&
        !(spouseNotary as TransferTask).completedOn &&
        (currentScreen === STEP_IDENTITY_VERIFICATION ||
          currentScreen === STEP_IDENTITY_VERIFICATION_PERSONA ||
          currentScreen === STEP_TRANSFER_TASKS)
      ) {
        goToScreen(STEP_SPOUSE_NOTARY);
      } else {
        goToScreen(STEP_ANNUITY_CONTACT);
      }
    } else {
      // DO NOT NEED TO CHECK THE STATUS in dev environment
      if (currentScreen === STEP_TRANSFER_TASKS && idTask) {
        goToScreen(STEP_IDENTITY_VERIFICATION);
      } else if (
        (currentScreen === STEP_IDENTITY_VERIFICATION ||
          currentScreen === STEP_IDENTITY_VERIFICATION_PERSONA ||
          currentScreen === STEP_TRANSFER_TASKS) &&
        spouseNotary
      ) {
        goToScreen(STEP_SPOUSE_NOTARY);
      } else {
        goToScreen(STEP_ANNUITY_CONTACT);
      }
    }
  };

  useEffect(() => {
    if (currentScreen === STEP_TRANSFER_TASKS) {
      goToNextTask();
    }
  }, [currentScreen]);

  return {
    isMock,
    currentScreen,
    showPersona,
    onFinishPersona,
    idTask,
    onClickGotIt,
    goToNextTask,
  };
};

export default useTransferTasks;
